import { useRef, useState } from "react";
import { validateConfirmPin, validateEmailMobile, validatePassword } from "./LoginValidate";
import Title, { ConfirmPin, EmailMobile, Message, Password, SubmitClearButton } from "./LoginUtil";
import { encrypt, handleInput, handleReset } from "../Common/Util";
import { axiosErrorHandler, axiosPost, axiosResponseHandler } from "../Common/axios";

export function ForgotPin () {
  const [message, setMessage] = useState('');
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [confirmpin, setConfirmpin] = useState('');
  const setMethod = { setEmail, setPassword, setPin, setConfirmpin, setMessage };

  const emailReference = useRef();
  const passwordReference = useRef();
  const pinReference = useRef();
  const confirmpinReference = useRef();


  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validateEmailMobile(event,emailReference,email);
    if(msg==='') msg = validatePassword(event, passwordReference,password);
    if(msg==='') msg = validateConfirmPin(event, pinReference,pin,confirmpinReference, confirmpin);
    setMessage(msg); 

    if(msg==='') {
      const data = {
        emailOrMobile: email,
        password: ''+encrypt(password),
        newPin : ''+encrypt(pin),
        confirmPin : ''+encrypt(confirmpin)
      }
      axiosPost("/astrologer/forgotpin", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, emailReference, ()=>handleReset(setMethod,emailReference), "Pin is changed successfully"));
        },
        (error)=>{
          setMessage(axiosErrorHandler(emailReference,error));
        }
      );
    }
    event.preventDefault();
  }

  return (
    <div class="container text-start bg-white ">
      <Title title="Forgot Pin"/>
      <Message msg={message} />    
      <form method="post" onSubmit={handleSubmit}>
        <EmailMobile reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)} />
        <Password reference={passwordReference} data={password} callback={(event)=>handleInput(event,setMethod)} />
        <ConfirmPin reference={pinReference} confirmreference={confirmpinReference} value={pin} confirmvalue={confirmpin} callback={(event)=>handleInput(event,setMethod)} />
        <SubmitClearButton callback={()=>handleReset(setMethod,emailReference)}/>
      </form>
    </div> 
  );
}
